module.exports = __webpack_public_path__ + "img/brand-21.495c7df0.png";